import * as actionTypes from "./actionTypes";

export const actions = {
  newOrderSuccess: (payload) => ({
    type: actionTypes.PLACE_NEW_ORDER_SUCCESS,
    payload,
  }),
  newOrderRequest: (payload) => ({
    type: actionTypes.PLACE_NEW_ORDER_REQUEST,
    payload,
  }),
  getAllOrdersReq: (payload = {}) => {
    return {
      type: actionTypes.GET_ALL_PLACED_ORDERS_REQUEST,
      payload,
    };
  },
  getMoreOrdersReq: (payload = {}) => {
    return {
      type: actionTypes.GET_MORE_PLACED_ORDERS_REQUEST,
      payload,
    };
  },
  setSelectedOrder: (payload) => {
    return {
      type: actionTypes.SET_SELECTED_ORDER,
      orderId: payload.orderId ?? payload,
      isVacationOrder: payload.isVacationOrder || false,
      source: payload.source || "FORWARD",
    };
  },
  setOrderDetails: (payload) => ({
    type: actionTypes.SET_ORDER_DETAILS,
    payload,
  }),
  emptyOrderList: () => ({
    type: actionTypes.EMPTY_ORDER_LIST,
  }),
  fetchCancellationReasonsRequest: () => ({
    type: actionTypes.FETCH_ORDER_CANCELLATION_REASONS_REQUEST,
  }),
  fetchCancellationReasonsSuccess: (reasons = []) => ({
    type: actionTypes.FETCH_ORDER_CANCELLATION_REASONS_SUCCESS,
    reasons,
  }),
};

const initialState = {
  allOrders: [],
  loading: true,
  totalCount: null,
  selectedOrder: "",
  cancellationReasons: [],
  isVacationOrder: false,
  source: "FORWARD",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_PLACED_ORDERS_REQUEST: {
      return { ...state, loading: true };
    }

    case actionTypes.GET_ALL_PLACED_ORDERS_SUCCESS: {
      return {
        ...state,
        allOrders: action.orders.orders,
        loading: false,
        totalCount: action.orders.count,
      };
    }
    case actionTypes.GET_MORE_PLACED_ORDERS_SUCCESS: {
      return {
        ...state,
        allOrders: state.allOrders.concat(action.orders.orders),
        loading: false,
      };
    }
    case actionTypes.SET_SELECTED_ORDER: {
      return {
        ...state,
        selectedOrder: action.orderId ?? action.payload,
        isVacationOrder: action.isVacationOrder ?? false,
        source: action.source ?? "FORWARD",
      };
    }

    case actionTypes.FETCH_ORDER_CANCELLATION_REASONS_SUCCESS:
      return {
        ...state,
        cancellationReasons: action.reasons,
      };
  }
  return state;
};
reducer.initialState = initialState;

export default reducer;
